import React from 'react';

//Data
import { useCtx } from '../../../config/hooks';

//UI
import {
	IonCard,
	IonCardContent,
	IonGrid,
	IonCol,
	IonRow,
	IonContent,
	IonButton,
	IonIcon
} from '@ionic/react';
import { mailOutline } from 'ionicons/icons';
import { useToast } from '@agney/ir-toast';
import EmailSendModal from '../components/EmailSendModal';
import { UserList } from './../containers/User';
import { PageTitle } from './../../../app/ui/components/PageTitle';
import { ServiceNotFoundCard } from './../components/Service/ServiceNotFoundCard';

const UsersView: React.FC = () => {
	const ctx = useCtx<{}>({});
	const {
		config: [config],
		app: { activeUser },
		lead: {
			activeService,
			activeEvent,
			contextHelper,
			licenseHelper,
			activeContext
		}
	} = ctx;

	const [showSendEmailModal, setShowSendEmailModal] = React.useState(false);
	const [currentEmailType, setCurrentEmailType] = React.useState<
		'licenses' | 'invite'
	>('licenses');
	const Toast = useToast();

	if (!activeService) return <ServiceNotFoundCard />;

	// Collect licenses (for validation when sending license emails)
	const contexts = activeEvent
		? ctx?.lead?.context?.allByEventId?.(activeEvent.id) || []
		: [];
	const licenses = activeEvent
		? licenseHelper.allByContexts(contexts, [activeService])
		: [];

	const openSendEmailModal = (type: 'licenses' | 'invite') => {
		if (type === 'licenses' && (!licenses || licenses.length === 0)) {
			Toast.error('There are no licenses to send!');
			return;
		}
		setCurrentEmailType(type);
		setShowSendEmailModal(true);
	};

	const handleSendEmail = async (email: string) => {
		if (currentEmailType === 'licenses') {
			await licenseHelper.sendLicensesEmail(ctx, {
				to: email,
				contextId: activeContext?.id || '',
				serviceId: activeService?.id,
				eventName: activeEvent?.name
			});
			Toast.success('User invitation email sent.');
		} else {
			await ctx.lead.user.sendInviteEmail(ctx, {
				to: email,
				contextId: activeContext?.id || '',
				serviceId: activeService?.id,
				eventName: activeEvent?.name
			});
			Toast.success('Admin invitation email sent.');
		}
	};

	return (
		<IonContent>
			<EmailSendModal
				isOpen={showSendEmailModal}
				onDismiss={() => setShowSendEmailModal(false)}
				emailType={currentEmailType}
				defaultEmail=""
				onSend={handleSendEmail}
			/>
			<IonGrid>
				<IonRow>
					<IonCol size="12" class="ion-text-start">
						<PageTitle title="Representatives" displayEventSelector={true} />
					</IonCol>
					{activeEvent && (
						<IonCol size="12" class="ion-text-end">
							<IonButton
								size="small"
								onClick={() => openSendEmailModal('licenses')}
								hidden={!activeEvent}
							>
								<IonIcon slot="start" icon={mailOutline} />
								Invite User
							</IonButton>
							<IonButton
								size="small"
								onClick={() => openSendEmailModal('invite')}
								hidden={!activeEvent}
							>
								<IonIcon slot="start" icon={mailOutline} />
								Invite Admin
							</IonButton>
						</IonCol>
					)}
				</IonRow>
				{activeEvent && (
					<IonRow>
						<IonCol>
							<IonCard>
								<IonCardContent>
									<UserList service={activeService} context={activeContext} />
								</IonCardContent>
							</IonCard>
						</IonCol>
					</IonRow>
				)}
			</IonGrid>
		</IonContent>
	);
};

export default UsersView;
